import { render } from "./AppPartners.vue?vue&type=template&id=68af1455&scoped=true"
import script from "./AppPartners.vue?vue&type=script&lang=js"
export * from "./AppPartners.vue?vue&type=script&lang=js"

import "./AppPartners.vue?vue&type=style&index=0&id=68af1455&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68af1455"]])

export default __exports__